const BASE_URL = process.env.BASE_URL || "/";
const wowzaApi = process.env.VUE_APP_STREAMING_SERVER || "/";
const fileServer = process.env.VUE_APP_FILE_SERVER || "/";
const streamServer = process.env.VUE_APP_VDO_STREAMING_SERVER || "/";
const xRegisWestern = process.env.VUE_APP_XREGIS_WESTERN_WEBAPP || "https://xregis.western.ac.th";
const xRegisNation = process.env.VUE_APP_XREGIS_NATION_WEBAPP || "https://xregis.nation.ac.th";
const xRegisDemo = process.env.VUE_APP_XREGIS_DEMO_WEBAPP || "https://xregis.27antz.com/";
const xtraFileServer = process.env.VUE_APP_XTRA_FILE_DOCMENT_SERVER || "https://api.xtrathai.com/document/api/v1";
import {getECode, getRStage} from "@/utils/auth-data";

export const config = {
  fileExtension: {
    csv: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    video: 'video/*',
    image: 'image/*',
    images: 'image/*',
    document: '.csv,' +
      ' application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
      ' application/vnd.ms-excel,' +
      ' .doc,' +
      ' .docx,' +
      ' .pdf' +
      ' application/vnd.ms-powerpoint,' +
      ' application/mspowerpoint,' +
      ' application/x-mspowerpoint,' +
      ' application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  url: {
    vdoOnDemandApi: `${wowzaApi}/video-upload`,
    vdoIntroductionApi: `${wowzaApi}/video-upload`,
    liveVdoApi: `${wowzaApi}/upload-vdo-live-set`,
    uploadFiles: `${fileServer}/upload`,
    uploadAvatar: `${fileServer}/upload`,
    downloadFile: `${fileServer}/${getECode}/${getRStage}/`,
    noAvatarImage: BASE_URL + 'static/images/no-avatar.png',
    noPhotoImage: BASE_URL + 'static/images/NoPhotoAvailable.jpg',
    downloadVideo: `${fileServer}/video`,
    xRegisWestern,
    xRegisNation,
    xRegisDemo,
    checkVideoCorrupt: `${wowzaApi}/is-video-corrupt`,
    // TODO SET ENDPOINT FOR XTRA FILE SERVER
    xtraFileServer: `${xtraFileServer}/files/upload/course_content`,
  },
  prefixFileName: {
    vdoOnDemand: 'ODM',
    vdoIntroduction: 'VID',
    vdoLiveSet: 'VLS'
  },
  operationName: {
    staffAvatar: 'image-upload',
    teacherAvatar: 'image-upload',
    studentAvatar: 'image-upload',
    classAssignment: 'document-upload',
    classMaterial: 'document-upload',
    courseOutline: 'image-upload',
    coverPhoto: 'image-upload',
    attachmentFile: 'document-upload',
  },
  baseUrl: BASE_URL,
  streamServer: streamServer,
  xtraFileServerToken: process.env.VUE_APP_XTRA_FILE_SERVER_TOKEN,
};

export function getAvatarUrl(picturePath) {
  if (picturePath) {
    return config.url.downloadFile + picturePath;
  } else {
    return BASE_URL + 'static/images/no-avatar.png'
  }
}

export function getPhotoUrl(picturePath) {
  if (picturePath) {
    // return config.url.downloadFile  + picturePath;
    return `${config.url.downloadFile}${picturePath}`;
  } else {
    return BASE_URL + 'static/images/NoPhotoAvailable.jpg'
  }
}

export function getXRegisStudentPhoto(studentId) {
  if (studentId) {
    const eCode = getECode;
    let url = ''
    if (eCode === 'x-studi-western') {
      url = xRegisWestern
    } else if (eCode === 'x-studi-nation') {
      url = xRegisNation
    } else {
      url = xRegisDemo
    }


    return `${url}/stdphoto/${studentId}`;
  } else {
    return BASE_URL + 'static/images/no-avatar.png'
  }
}

export function getAppId() {
  const eCode = getECode;

  if (eCode === 'x-studi-western') {
    return process.env.VUE_APP_WESTERN_APP_ID
  } else if (eCode === 'x-studi-nation') {
    return process.env.VUE_APP_NATION_APP_ID
  } else {
    return process.env.VUE_APP_WESTERN_APP_ID
  }
}
